export const FETCH_SONG_RELEASE_DATA_REQUEST = 'FETCH_SONG_RELEASE_DATA_REQUEST'
export const FETCH_SONG_RELEASE_DATA_FAILURE = 'FETCH_SONG_RELEASE_DATA_FAILURE'
export const FETCH_SONG_RELEASE_DATA_SUCCESS = 'FETCH_SONG_RELEASE_DATA_SUCCESS'